import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ReactPaginate from 'react-paginate';
import s from './Pagination.module.scss';
import classNames from 'classnames';
import { ACTION_TYPES } from '../../containers/EventListPage/EventListPage';
import { EventListPageContext } from '../../containers/EventListPage/EventListPageContext';

const Pagination = () => {
  const { state, dispatch } = useContext(EventListPageContext);
  const { currentPage = 1, totalPages = 1 } = state?.pagination || {};

  const handlePageChange = (selectedItem) => {
    const page = selectedItem.selected + 1;
    dispatch({
      type: ACTION_TYPES.CHANGE_PAGE,
      page,
    });

    setTimeout(() => {
      const element = document.getElementById('top-of-search');
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 150;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }, 50);
  };

  return (
    <div className={s.Pagination}>
      <ReactPaginate
        forcePage={currentPage - 1}
        onPageChange={handlePageChange}
        hrefAllControls={true}
        containerClassName={s.List}
        pageClassName={s.Item}
        pageLinkClassName={s.Link}
        breakClassName={s.Break}
        activeClassName={classNames(s.Link, s.LinkActive)}
        previousLinkClassName={classNames(
          s.Link,
          s.LinkChevron,
          s.LinkChevronLeft
        )}
        nextLinkClassName={classNames(
          s.Link,
          s.LinkChevron,
          s.LinkChevronRight
        )}
        previousClassName={classNames(s.Item, s.ItemChevron, s.ItemChevronLeft)}
        nextClassName={classNames(s.Item, s.ItemChevron, s.ItemChevronRight)}
        disabledClassName={classNames(s.Item, s.LinkDisabled)}
        disabledLinkClassName={classNames(s.Link, s.LinkDisabled)}
        breakLabel="..."
        pageRangeDisplayed={2}
        marginPagesDisplayed={2}
        pageCount={totalPages}
        previousLabel={null}
        nextLabel={null}
        renderOnZeroPageCount={null}
      />
    </div>
  );
};

Pagination.propTypes = {
  totalPages: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default Pagination;
